import React from 'react';

const footerLinks = [
  { name: 'Wells para TVP', description: 'Critérios, pontuação e conduta', url: '/wells-tvp/' },
  { name: 'Wells para TEP', description: 'Critérios, pontuação e conduta', url: '/wells-tep/' },
  { name: 'Escore HEART', description: 'Avaliação de dor torácica', url: 'https://escoreheart.com.br/' },
  { name: 'CURB-65', description: 'Contexto de pneumonia', url: 'https://curb65.com.br/' },
];

function FooterLinks() {
  return (
    <footer className="site-footer">
      <div className="footer-links">
        {footerLinks.map((link) => (
          <a href={link.url} key={link.name}>
            <span>{link.name}</span>
            <span>{link.description}</span>
          </a>
        ))}
      </div>
      <p>calculadorawells.com.br © {new Date().getFullYear()}</p>
      <p>Ferramenta educativa. Não substitui avaliação médica profissional.</p>
    </footer>
  );
}

export default FooterLinks;
